<template>
  <div id="popoverPannel" class="popover-container" :style="styleObject" v-show="popoverVisable">
    <div v-for="item in dumpList" :key="item.id" @click="forwardOverview(item.id)">
      {{item.name}}
    </div>
  </div>
</template>

<script>

export default {
  name: 'popoverPannel',
  props: ['dumpList', 'popoverVisable', 'styleObject'],
  data() {
    return {
    };
  },
  methods: {
    forwardOverview(projectId) {
      this.$router.push({ path: `/bigdata/overview/${projectId}` });
    },
  },
};

</script>

<style lang="scss" scoped>
   @import '~@/theme/app.scss';

  .popover-container {
    position: absolute;
    transform: 'none';
    z-index: 500;
    color: $font-color;
    overflow-y: auto;
    min-height: 150px;
    max-height: 200px;
    width: 300px;
    text-align: center;
    border: 1px solid #0096EA;
    border-radius: 8px;
    background-color: #262041;
    padding: 0.5rem 1rem;
    > div {
      padding: 0.5rem 0.5rem;
      border-bottom: 1px solid rgba(#FFFFFF, 0.2);
      cursor: pointer;
      &:last-child {
        border-bottom: none;
      }
      &:hover {
        color: #01CDFE;
        font-weight: bold;
      }
    }
  }

</style>
